<template>
  <div class="simulationDetail">
    <div class="banner">
      <img src="../assets/simulation/banner.png" alt />
      <div class="simtitle">
        <img src="../assets/simulation/logo.png" alt />
        <span style="font-weight: 600">仿真实训</span>
      </div>
    </div>
    <div class="content">
      <div class="navtitle">
        <p class="navlist">
          <span @click="backHome">首页</span>>
          <span @click="backsimulation">仿真实训中心</span>>
          <span style="color: #999">详情</span>
        </p>
        <div class="backbtn" @click="toback">
          <span></span>
          <span>返回</span>
        </div>
      </div>
      <div class="course"></div>
      <h2>{{ detailList.softName }}</h2>

      <div class="subject">
        <div class="title">
          <span>概述</span>
        </div>
        <div class="info ql-editor" v-html="detailList.info">
          <!-- <p v-html="detailList.info"></p> -->
        </div>
      </div>

      <!-- 支持课程 -->
      <!-- <div class="subject">
        <div class="title">
          <span>支持课程</span>
        </div>
        <div class="info">
          <p>本仿真实训系统支持工业机器人基础/技术、工业机器人拆装与调试、工业机器人故障诊断等课程的虚拟仿真实验教学。可开展工业机器人基础认知、工业机器人结构认知、工业机器人装配与调试等在线仿真实训项目。</p>
          <br />
          <p>开展的教学设计可为:</p>
          <p>1）工业机器人基础（理论授课）+工业机器人基础认知与本体结构拆卸虚拟仿真实训（虚拟仿真实训）；</p>
          <p>2）工业机器人拆装与调试（理论授课）+工业机器人本体拆卸与装配虚拟仿真实训（仿真实训）+工业机器人机械拆装与调试实训（设备实训），实现虚实结合教学模式。</p>
        </div>
      </div> -->

      <!-- 教学对象 -->
      <!-- <div class="object">
        <div class="title">
          <span>教学对象</span>
        </div>
        <div class="info">
          <p>教学对象：中职、高职、应用型本科开设工业机器人专业或开设工业机器人方向课程的在校学生、企业工业机器人操调工、装调工、集成应用工程师等。</p>
        </div>
      </div> -->

      <!-- 实训项目 -->
      <!-- <div class="train">
        <div class="title">
          <span>教学对象</span>
        </div>
        <div class="info">
          <p>通过本系统工作任务的完成，使学生了解工业机器人的分类、特点、组成、工作原理等基本理论和技术，掌握工业机器人的安装与调试的一般方法与流程，具备工业机器人的安装、调试、工具使用、操作规范等解决实际问题的基本技能。通过系统的虚拟技术实现学习的反复练习，结构解剖等教学活动，提高学生对工业机器人的熟悉与认知程度。</p>
          <p>1） 能完成相关资料的检索。</p>
          <p>2） 能概述工业机人的结构组成和工作原理。</p>
          <p>3）能够正确阅读工业机器人部件装配图、零件图和技术文件，进行机械部件装配。</p>
          <p>4） 能够编写适用于不同工作任务的工业机器人调试程序。</p>
          <p>5） 能够使用工业机器人安装与调试常用的机械工具，电子工具和相关仪器仪表。</p>
          <p>6） 能够及时详细地记录工业机器人安装与调试过程的工作日记、总结工作经验已供日后的使用。</p>
          <p>7） 能够学会机器人的模块化组装、调试方法。</p>
        </div>
      </div> -->

      <!-- 产品案例 -->
      <!-- <div class="product">
        <div class="title">
          <span>产品案例</span>
        </div>
        <div class="info">
          <h3>{{ detailList.title }}</h3>
          <ul>
            <li v-for="item in detailList.image" :key="item.id">
              <img :src="require('../assets/training' + item)" alt />
            </li>
          </ul>
        </div>
      </div> -->

      <!-- 底部 -->
      <div class="footer">
        <div @click="apply(detailList.id)">
          <span></span>
          <span>申请试用</span>
        </div>
        <div @click="download(detailList.downloadUrl)">
          <span></span>
          <span>软件下载</span>
        </div>
      </div>
    </div>
    <a-modal
      title="申请试用"
      :visible="isapply"
      @ok="applyOk"
      @cancel="isapply = false"
      okText="提交"
      cancelText="取消"
      :destroyOnClose="true"
      class="isshowmodal"
    >
      <!-- <div>
        <p>详情请咨询：</p>
        <p>电话：027-87528232</p>
        <p>邮箱：market@gdcourse.com</p>
      </div> -->
      <p>请您如实填写下列信息，我们会尽快与您联系！</p>
      <eform title="申请试用" :formData="formData" class="formbox" ref="form">
        <div slot="name">
          <a-input
            v-decorator="[
              'name',
              {
                rules: [
                  { required: true, message: ' ' },
                  { validator: validatorname },
                ],
              },
            ]"
            class="input"
            placeholder="请输入您的姓名"
          />
        </div>
        <div slot="address">
          <a-input
            v-decorator="[
              'address',
              {
                rules: [
                  { required: true, message: '' },
                  { validator: validatoraddress },
                ],
              },
            ]"
            class="input"
            placeholder="请输入您的单位"
          />
        </div>
        <div slot="phone">
          <a-input
            v-decorator="[
              'phone',
              {
                rules: [
                  { required: true, message: ' ' },
                  { validator: validatorphone },
                ],
              },
            ]"
            class="input"
            placeholder="请输入您的手机号码"
          />
        </div>
        <div slot="job">
          <a-input
            v-decorator="[
              'job',
              {
                rules: [
                  { required: true, message: ' ' },
                  { validator: validatorjob },
                ],
              },
            ]"
            class="input"
            placeholder="请输入您的姓名"
          />
        </div>
        <div slot="email">
          <a-input
            v-decorator="[
              'email',
              {
                rules: [
                  { required: true, message: ' ' },
                  { validator: validatoremail },
                ],
              },
            ]"
            class="input"
            placeholder="请输入您的姓名"
          />
        </div>
        <div slot="content" class="conbox">
          <a-textarea
            class="applycon"
            placeholder="请输入您的重点需求"
            v-decorator="[
              'content',
              {
                rules: [
                  { required: true, message: ' ' },
                  { validator: validatorinfo },
                ],
              },
            ]"
          >
          </a-textarea>
        </div>
      </eform>
    </a-modal>
  </div>
</template>

<script>
import eform from "@/components/common/form";
import list from "@/request/mock";
import { getsimulationDetailApi, getcommitApplyApi } from "@/request/api";
export default {
  name: "simulationDetail",
  components: { eform },
  data() {
    const formData = [
      {
        label: "姓名",
        scopedSlots: { customRender: "name" },
      },
      {
        label: "单位",
        scopedSlots: { customRender: "address" },
      },
     {
        label: "职务",
        scopedSlots: { customRender: "job" },
      },
      {
        label: "电话",
        scopedSlots: { customRender: "phone" },
      },
      {
        label: "邮箱",
        scopedSlots: { customRender: "email" },
      },
      {
        label: "描述",
        scopedSlots: { customRender: "content" },
      },
    ];
    let validatorname = (rule, value, callback) => {
      let reg = /^[\u4e00-\u9fa5]/;
      if (value == "" || reg.test(value)) {
        this.username = value;
        callback();
      } else {
        callback(new Error("请输入真实姓名"));
      }
    };
    let validatorjob = (rule, value, callback) => {
      if (value.trim()) {
        if (value == "" || value) {
          this.job = value;
          callback();
        } else {
          callback(new Error("请输入您的职务"));
        }
      } else {
        callback(new Error("请输入您的职务"));
      }
    };
     let validatoremail = (rule, value, callback) => {
      let reg = /^[\w]\w{0,20}@(qq.com|126.com|163.com|QQ.com)$/;
      if (value == "" || reg.test(value)) {
        this.email = value;
        callback();
      } else {
        callback(new Error("请输入合法邮箱"));
      }
    };
    let validatoraddress = (rule, value, callback) => {
      if (value.trim()) {
        if (value == "" || value) {
          this.useraddress = value;
          callback();
        } else {
          callback(new Error("请输入您的单位"));
        }
      } else {
        callback(new Error("请输入您的单位"));
      }
    };
    let validatorinfo = (rule, value, callback) => {
      if (value.trim()) {
        if (value == "" || value) {
          this.userinfo = value;
          callback();
        } else {
          callback(new Error("请输入描述"));
        }
      } else {
        callback(new Error("请输入描述"));
      }
    };
    let validatorphone = (rule, value, callback) => {
      var regphone = /^1[3456789]\d{9}$/;
      if (regphone.test(value)) {
        this.userphone = value;
        callback();
      } else {
        callback(new Error("请输入正确格式的手机号"));
      }
    };
    return {
      detailId: "",
      detailList: [],
      isshow: false,
      formData,
      validatorphone,
      validatoraddress,
      validatorname,
      validatorinfo,
      validatoremail,
      validatorjob,
      job: "",
      email: "",
      username: "",
      userinfo: "",
      userphone: "",
      useraddress: "",
      apiUrl: window.g.apiUrl,
      isapply: false,
      productId: "",
      page: "",
    };
  },
  created() {
    this.page = this.$Base64.decode(this.$route.query.page);
    // this.page=this.$route.query.page
    this.detailId = this.$Base64.decode(this.$route.query.id);
    // console.log(this.detailId)
    this.init();
  },
  methods: {
    init() {
      this.getToken(
        getsimulationDetailApi,
        { productId: this.detailId },
        (res) => {
          this.detailList = res.data;
        }
      );
    },
    backHome() {
      this.$router.push({ path: "/" });
    },
    backsimulation() {
      this.$router.push({
        path: "/simulation",
        query: {
          page: this.$Base64.encode(this.page),
          // page:this.page
        },
      });
    },
    toback() {
      this.$router.push({
        path: "/simulation",
        query: {
          page: this.$Base64.encode(this.page),
          // page:this.page
        },
      });
    },
    //申请试用
    apply(id) {
      this.isapply = true;
      this.productId = id;
    },
    applyOk() {
      if (this.username) {
        if (this.useraddress) {
          if (this.job) {
            if (this.userphone) {
              if (this.email) {
                if (this.userinfo) {
                  this.$refs.form.form.validateFields().then((res) => {
                    console.log(res);
                    this.getToken(
                      getcommitApplyApi,
                      {
                        productId: this.productId,
                        user: res.name,
                        institute: res.address,
                        telephone: res.phone,
                        info: res.content,
                        title: res.job,
                        email: res.email,
                      },
                      (val) => {
                        if (val.code == 200) {
                          this.$message.success("申请成功");
                          this.isapply = false;
                        }
                      }
                    );
                  });
                } else {
                  this.$message.error("请输入描述信息");
                }
              } else {
                this.$message.error("请输入邮箱");
              }
            } else {
              this.$message.error("请输入联系方式");
            }
          } else {
            this.$message.error("请输入职务");
          }
        } else {
          this.$message.error("请输入单位信息");
        }
      } else {
        this.$message.error("请输入用户姓名");
      }
    },
    applycancel() {
      this.isapply = false;
    },
    //软件下载
    download(url) {
      this.$confirm({
        title: "请访问如下网址进行下载",
        okText: "知道了",
        content: url,
        cancelText: "取消",
        onOk() {
          // console.log("OK");
        },
        onCancel() {
          // console.log("Cancel");
        },
      });
    },
  },
};
</script>
<style lang="stylus">
.isshowmodal {
  p {
    color: #000;
    text-align: center;
    font-size: 16px;
  }
}

.formbox textarea.ant-input {
  margin-bottom: 4px;
  min-height: 200px;
}

.formbox .ant-form-item-label label {
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
}

.isshowmodal .ant-modal-title {
  margin: 0;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
  font-size: 20px;
  line-height: 22px;
}

.isshowmodal .ant-modal-close-x {
  color: #666;
  font-size: 25px;
}
</style>
<style lang="stylus" scoped>
.simulationDetail {
  background: #eee;
  overflow: hidden;

  .banner {
    height: 100px;
    margin: 0 auto;
    position: relative;
    margin-bottom: 11px;

    img {
      width: 100%;
      height: 100%;
    }

    .simtitle {
      width: 1205px;
      padding-left: 40px;
      position: absolute;
      display: flex;
      align-items: center;
      left: 50%;
      bottom: 23px;
      transform: translateX(-50%);
      z-index: 555;

      img {
        width: 46px;
        height: 46px;
      }

      span {
        font-size: 22px;
        color: #fff;
        margin-left: 11px;
      }
    }
  }

  .content {
    background: #fff;
    width: 1205px;
    margin: 0 auto;
    min-height: 500px;
    margin-bottom: 12px;
    padding: 30px 50px 24px 50px;

    .navtitle {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #eee;
      width: 100%;

      .navlist {
        display: flex;
        font-size: 14px;
        color: #333;
        margin-bottom: 5px;

        span:nth-child(1) {
          cursor: pointer;
        }

        span:nth-child(2) {
          cursor: pointer;
        }

        span:nth-child(1):hover {
          color: #ef9545;
        }

        span:nth-child(2):hover {
          color: #ef9545;
        }
      }

      .backbtn {
        display: flex;
        justify-content: center;
        align-items: center;

        span:nth-child(1) {
          display: block;
          width: 21px;
          height: 21px;
          background: url('../assets/simulation/back.png');
        }

        span:nth-child(2) {
          font-family: MicrosoftYaHei;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 36px;
          letter-spacing: 0px;
          color: #333333;
          margin-left: 5px;
        }
      }

      .backbtn:hover {
        cursor: pointer;

        span:nth-child(2) {
          color: #ef9545;
        }

        span:nth-child(1) {
          background: url('../assets/simulation/back1.png');
        }
      }
    }

    h2 {
      color: #b49216;
      font-size: 20px;
      text-align: center;
      background-color: #f6f6f6;
      margin-top: 31px;
      font-weight: 600;
      height: 40px;
      line-height: 40px;
    }

    .course {
      overflow: hidden;
      margin-bottom: 40px;

      .title {
        border-bottom: 1px solid #d0d0d0;
        margin-top: 33px;

        span {
          color: #424242;
          font-size: 14px;
          font-weight: bold;
          display: block;
          width: 107px;
          text-align: center;
          border-bottom: 3px solid #d0d0d0;
        }
      }
    }

    .subject {
      overflow: hidden;
      margin-bottom: 40px;
      min-height: 300px;

      .title {
        border-bottom: 1px solid #d0d0d0;

        span {
          color: #424242;
          font-size: 14px;
          font-weight: bold;
          display: block;
          width: 107px;
          text-align: center;
          border-bottom: 3px solid #d0d0d0;
        }
      }

      .info {
        margin-top: 12px;
        text-indent: 32px;

        p {
          font-size: 14px;
          color: #333333;
          margin-bottom: 0px;
          text-indent: 32px;
        }
      }
    }

    .object {
      overflow: hidden;
      margin-bottom: 40px;

      .title {
        border-bottom: 1px solid #424242;

        span {
          color: #424242;
          font-size: 14px;
          font-weight: bold;
          display: block;
          width: 107px;
          text-align: center;
          border-bottom: 3px solid #424242;
        }
      }

      .info {
        margin-top: 12px;

        p {
          font-size: 14px;
          color: #333333;
          margin-bottom: 0px;
          text-indent: 28px;
        }
      }
    }

    .train {
      overflow: hidden;
      margin-bottom: 40px;

      .title {
        border-bottom: 1px solid #424242;

        span {
          color: #424242;
          font-size: 14px;
          font-weight: bold;
          display: block;
          width: 107px;
          text-align: center;
          border-bottom: 3px solid #424242;
        }
      }

      .info {
        margin-top: 12px;
        text-indent: 32px;

        p {
          font-size: 14px;
          color: #333333;
          margin-bottom: 0px;
          text-indent: 32px;
        }
      }
    }

    .product {
      .title {
        border-bottom: 1px solid #d0d0d0;

        span {
          color: #424242;
          font-size: 14px;
          font-weight: bold;
          display: block;
          width: 107px;
          text-align: center;
          border-bottom: 3px solid #d0d0d0;
        }
      }

      .info {
        padding: 25px 27px 10px 21px;

        h3 {
          color: #393838;
          font-size: 18px;
          margin-bottom: 15px;
        }

        ul {
          display: flex;
          flex-wrap: wrap;

          li {
            width: 490px;
            height: 275px;
            margin-right: 60px;
            margin-bottom: 28px;

            img {
              width: 100%;
              height: 100%;
            }
          }

          li:nth-child(2n) {
            margin-right: 0px;
          }
        }
      }
    }

    .footer {
      border-top: 1px solid #d0d0d0;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      height: 90px;
      align-items: center;

      div:nth-child(1) {
        width: 155px;
        height: 46px;
        background: #f0cd48;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 58px;
        border-radius: 23px;
        cursor: pointer;

        span:nth-child(1) {
          display: block;
          width: 19px;
          height: 18px;
          background: url('../assets/simulation/apply.png');
        }

        span:nth-child(2) {
          color: #333;
          font-size: 16px;
          margin-left: 7px;
        }
      }

      div:nth-child(2) {
        width: 155px;
        height: 46px;
        background: #f0cd48;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 58px;
        border-radius: 23px;
        cursor: pointer;

        span:nth-child(1) {
          display: block;
          width: 19px;
          height: 18px;
          background: url('../assets/simulation/down.png');
        }

        span:nth-child(2) {
          color: #333;
          font-size: 16px;
          margin-left: 7px;
        }
      }
    }
  }
}
</style>
